import * as metricsServer from 'src/internal/metrics/metrics.server';

import type {ImperativeMetrics, ObservabilityConfig} from 'src/types';

const method = <TMethod extends keyof ImperativeMetrics>(
  name: TMethod,
): ImperativeMetrics[TMethod] => {
  return (config: ObservabilityConfig | null, ...params: [...any]): void => {
    if (!config || config.metrics?.disabled) {
      return;
    }

    const injectedMethod = config._internal_observability?.metrics?.[name];

    if (injectedMethod) {
      // @ts-expect-error Passed in `params` is a union of tuples.
      injectedMethod(config, ...params);
      return;
    }

    try {
      // @ts-expect-error Passed in `params` is a union of tuples.
      metricsServer[name](config, ...params);
    } catch (error) {
      // The errors here are unexpected. But if they happen, degrade gracefully:
      // - Don't crash the code calling @sail/observability APIs
      // - Report an unhandled exception so that it is reported to Sentry
      Promise.reject(error);
    }
  };
};

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-observability/api/useMetrics#increment
 */
export const increment = method('increment');

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-observability/api/useMetrics#gauge
 */
export const gauge = method('gauge');

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-observability/api/useMetrics#set
 */
export const set = method('set');
